import AuthenticationContext from "../utility/AuthenticationContext";
import { AuthenticationInfoType } from "../utility/types";

type IProps = {
  children: (auth: AuthenticationInfoType) => React.ReactNode;
};

const AuthenticationComponent = (props: IProps) => {
  return (
    <AuthenticationContext.Consumer>
      {(auth) => {
        if (!auth) {
          return <p>Sorry, no authentification. :-(</p>;
        } else {
          return props.children(auth);
        }
      }}
    </AuthenticationContext.Consumer>
  );
};

export default AuthenticationComponent;
